<template>
  <gj-modal
      size="700XAuto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      :confirm-text="confirmText"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>店铺授权</template>
    <template #content>
      <storeAuthorization
          :form="form"
          :unionAccountOption="unionAccountOption"
      ></storeAuthorization>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaningless, transformToMap} from "../../../../../utils/common";
  import {modalMixIn, responseMixin} from "../../../../../minxins";
  import {getMarketAuthUrl, marketApiAuth} from "../../../../../api/system";
  import {MarketEnum} from "../enum";

  import storeAuthorization from "../components/store-authorization"

  export default {
    name: "app-add-market-modal",
    mixins: [modalMixIn, responseMixin],
    components:{
      storeAuthorization
    },
    data() {
      return {
        confirmLoading: false,
        form: {
          marketName: null,
          areaId: 'na',
          countryCodes: [],
          unionAccount: true
        },
        areaOption: MarketEnum.areaOption,
        countryOption: [],
        unionAccountOption: [
          {id: true, text: '是'},
          {id: false, text: '否'},
        ],
        confirmText: '授权'
      }
    },
    created() {
      this.areaInput(this.form.areaId);
      window.$marketAuthCallback = this.$marketAuthCallback;
    },
    methods: {
      areaInput(areaId) {
        const map = transformToMap(this.areaOption);
        this.countryOption = map[areaId].countryOption;
        this.form.countryCodes = [];
        let areaList = ['IN', 'AE', 'SA','SG', 'AU', 'JP']
        areaList.includes(areaId) && (this.form.countryCodes = [areaId])
      },
      confirm() {
        if (isMeaningless(this.form.countryCodes) || this.form.countryCodes.length === 0) {
          this.$gjMessage.error('请选择授权国家');
          return;
        }
        this.confirmLoading = true;
        getMarketAuthUrl({
          region: this.form.areaId,
          countryCodes: this.form.countryCodes
        })
          .then((authUrl) => {
            window.open(authUrl, "DisplayWindow", "toolbar=no,,menubar=no,location=no,scrollbars=no,height=610px,width=800px");
          })
          .complete(() => {
            this.confirmLoading = false;
          });
      },
      $marketAuthCallback(data) {
        this.confirmLoading = true;
        this.confirmText = '授权中';
        marketApiAuth(data)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('授权成功');
               this.$emit('authed');
               this.$gjDestroy();
            });
          })
          .complete(() => {
            this.confirmLoading = false;
            this.confirmText = '授权';
          });
      }
    }
  }
</script>

<style scoped>
  .form {
    height: 170px;
  }

  .country-checkbox {
     margin: 10px 0 0;
  }

  .country-checkbox /deep/ .el-form-item__label,
  .country-checkbox /deep/ .el-form-item__content {
    line-height: 20px;
  }
</style>
